import { useTranslation } from 'react-i18next';
import { CustomFieldOptionType } from '../../components/CustomField/CustomField.type';

const groupNameListCreatedBySystem = ['Default Group', 'Agents', 'Chat', 'Call'];
export function useTranslatedGroupOptions(
    options: Omit<CustomFieldOptionType, 'order'>[]
): Omit<CustomFieldOptionType, 'order'>[] {
    const { t } = useTranslation('forms');
    return (options ?? []).map((option) =>
        groupNameListCreatedBySystem.includes(option.label as string)
            ? { ...option, label: t(`form.GroupNames.${option.label}` as any) as string }
            : option
    );
}

export { groupNameListCreatedBySystem };
